import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PANEL_ITEM_PADDING_CSS } from '../../../../panels/panelItem';
import { ALL_BOMB_TYPES } from '../../../../types/bombTypes';
import { DraggableBombButton } from './draggableBombButton';
const CONTAINER_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    display: flex;
    flex-flow: row wrap;
    gap: 5px;
  `);
export const DraggableBombButtons = () => {
    return (_jsx("div", { css: CONTAINER_CSS, children: ALL_BOMB_TYPES.map((bombType) => (_jsx(DraggableBombButton, { bombType: bombType }, bombType))) }));
};
